<template>
  <div class="form-group row">
    <label class="col-form-label" :class="nolabel ? '' : 'col-sm-' + labelCol" v-if="nolabel !== true">{{ title || '&nbsp;' }}</label>
    <div :class="nolabel ? 'col-sm-12' : 'col-sm-' + (12 - labelCol)">
      <div class="form-check-wrapper" :class="{ invalid: !isValid }">
        <div ref="options" v-if="readonly !== true" v-for="option in options" class="form-check form-check-inline"  :key="option.Key">
          <label class="form-check-label">
            <input type="radio" class="form-check-input-styled" :name="id" :value="option.Key" @change="dataChanged" :checked="option.Key === d" />
            {{ option.Value }}
          </label>
        </div>
      </div>
      <input v-if="readonly" type="text" class="form-control" :value="valueText" readonly="readonly">
      <label v-if="isValid === false" id="basic-error" class="validation-invalid-label" for="basic">{{ $t('ui.SYS00016') }}</label>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CheckBox',
  props: ['id', 'title', 'value', 'options', 'readonly', 'required', 'labelwidth', 'nolabel'],
  data () {
    return {
      d: null,
      isValid: true
    }
  },
  mounted () {
    this.initRadio()
  },
  computed: {
    valueText () {
      var v = null
      if (this.d) {
        $.each(this.options, $.proxy(function (i, o) {
          if (this.d === o.Key) {
            v = o.Value
            return false
          }
        }, this))
      }

      return v
    },
    labelCol () {
      return this.labelwidth || 3
    }
  },
  methods: {
    setFocus () {
      $(this.$el).find(':radio').filter(':first').focus()
    },
    setValid (val) {
      this.isValid = val
    },
    isFieldValid () {
      return !this.required || (this.required && this.d !== null && this.d !== undefined && this.d !== '')
    },
    dataChanged (e) {
      this.d = $(e.target).val()
      this.$emit('input', this.d, this)
    },
    resetValue () {
      this.isValid = true
      $(this.$el).find(':radio').prop('checked', false)
    },
    initRadio () {
      $(this.$refs.options).find('.form-check-input-styled').uniform({
        wrapperClass: 'border-success-600 text-success-800'
      })
    }
  },
  watch: {
    value: function (val) {
      this.d = val
      $(this.$el).find(':radio[value="' + val + '"]').prop('checked', true)
      this.setValid(this.isFieldValid())
    }
  }
}
</script>
